export default __webpack_public_path__ + "static/sticky-header-logo-a1434a0bfc0d8a57d9cb03992174c93d.png";